import {
  GET_SEMESTERS,
  GET_SEMESTERS_FAIL,
  GET_SEMESTERS_SUCCESS,
  ADD_NEW_SEMESTER,
  ADD_SEMESTER_SUCCESS,
  ADD_SEMESTER_FAIL,
  UPDATE_SEMESTER,
  UPDATE_SEMESTER_SUCCESS,
  UPDATE_SEMESTER_FAIL,
  DELETE_SEMESTER,
  DELETE_SEMESTER_SUCCESS,
  DELETE_SEMESTER_FAIL,
  
} from "./actionTypes";

export const getSemesters = () => ({
  type: GET_SEMESTERS,
})

export const getSemestersSuccess = semesters => ({
  type: GET_SEMESTERS_SUCCESS,
  payload: semesters,
})

export const getSemestersFail = error => ({
  type: GET_SEMESTERS_FAIL,
  payload: error,
})

export const addNewSemester = semester => ({
  type: ADD_NEW_SEMESTER,
  payload: semester,
})

export const addSemesterSuccess = semester => ({
  type: ADD_SEMESTER_SUCCESS,
  payload: semester,
})

export const addSemesterFail = error => ({
  type: ADD_SEMESTER_FAIL,
  payload: error,
})

export const updateSemester = semester => ({
  type: UPDATE_SEMESTER,
  payload: semester,
})

export const updateSemesterSuccess = semester => ({
  type: UPDATE_SEMESTER_SUCCESS,
  payload: semester,
})

export const updateSemesterFail = error => ({
  type: UPDATE_SEMESTER_FAIL,
  payload: error,
})

export const deleteSemester = data => ({
  type: DELETE_SEMESTER,
  payload: data,
})

export const deleteSemesterSuccess = data => ({
  type: DELETE_SEMESTER_SUCCESS,
  payload: data,
})

export const deleteSemesterFail = error => ({
  type: DELETE_SEMESTER_FAIL,
  payload: error,
})



